import api from './api'

export const categoryService = {
  getAll: (params?: { search?: string; page?: number; limit?: number }) =>
    api.get('/categories', { params }),

  getById: (id: number) =>
    api.get(`/categories/${id}`),

  create: (data: {
    category_name: string
    description?: string
    parent_category_id?: number | null
  }) => api.post('/categories', data),

  update: (id: number, data: {
    category_name?: string
    description?: string
    parent_category_id?: number | null
  }) => api.put(`/categories/${id}`, data),

  delete: (id: number) =>
    api.delete(`/categories/${id}`),
}
